import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router/dist/vue-router.mjs'
import MaintenanceForm from '../views/MaintenanceForm.vue'
import ReservationSuccess from '../views/ReservationSuccess.vue'
import MyReservations from '../views/MyReservations.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: MaintenanceForm
  },
  {
    path: '/success/:data?',
    name: 'ReservationSuccess',
    component: ReservationSuccess
  },
  {
    path: '/my-reservations',
    name: 'MyReservations',
    component: MyReservations
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
